export default {
	canPublish: { type: Boolean },
	problematicNodes: { type: Array },
	showWarningIcon: { type: Boolean },
	allowedToPublish: { type: Boolean },
	isLoadedAsIframe: { type: Boolean },
};
